import msLocale from 'element-ui/lib/locale/lang/ms'
import home from './ms/home'

const ms = {
    language: 'Melayu',
    message: {
        'home': {
            ...home,
            enterEmail: 'Sila masukkan e-mel',
            save: 'Simpan',
            saveSuccess: 'Berjaya disimpan',
            pointHistory: 'Sejarah mata',
            type: 'Jenis',
            remark: 'Catatan',
            pendingComment: 'Menunggu penilaian',
            commented: 'Telah dinilai',
            selectDate: 'Pilih tarikh',
            loginSuccess: 'Log masuk berjaya',
            loginFail: 'Log masuk gagal',
            close: 'Tutup',
            required: 'Wajib',
            nickname: 'Nama samaran',
            enterNickname: 'Sila masukkan nama samaran',
            gender: 'Jantina',
            male: 'Lelaki',
            female: 'Perempuan',
            secret: 'Sulit',
            birthday: 'Hari lahir',
            checkoutLoadFailed: 'Gagal memuatkan maklumat pembayaran. Sila cuba lagi kemudian.',
            checkoutErrorTitle: 'Pemberitahuan',
            goAddAddress: 'Tambah alamat penghantaran',
            shop_order_selectOrAddAddress: 'Sila tambah alamat penghantaran dahulu dan tetapkan sebagai lalai sebelum membuat pembayaran.',
            shop_order_cartEmpty: 'Troli kosong, tidak boleh membuat pembayaran.',
            shop_order_cartHasNotActive: 'Terdapat produk yang belum disiarkan atau tidak sah, tidak boleh membuat pembayaran.',
            shop_order_cartHasNotMarketable: 'Terdapat produk yang telah ditarik, tidak boleh membuat pembayaran.',
            shop_order_cartHasLowStock: 'Stok tidak mencukupi, tidak boleh membuat pembayaran.',
            shop_order_cartHasExpiredGoods: 'Sesetengah produk kedai telah tamat tempoh, tidak boleh membuat pembayaran.',
            shop_order_typeIsNull: 'Jenis pesanan tidak dapat dikenal pasti, sila semak jenis produk.',
            shop_order_goodsNotFound: 'Maklumat produk tidak wujud atau telah dipadam.',
            shop_order_giftNotForSale: 'Produk hadiah tidak boleh dibeli secara terus.',
            common_message_badRequest: 'Permintaan tidak sah, sila semak produk dan parameter.',
        },
    },
    '手机号码最小长度为8位': "Panjang minimum nombor telefon bimbit ialah 8 digit.",
    '邮箱账号名称最小长度为6位': "Panjang minimum nama akaun e-mel ialah 6 aksara.",
    '邮箱只能包含英文，数字等字符': "Peti mel hanya boleh mengandungi aksara seperti bahasa Inggeris dan nombor",
    '请选择正确的收货地址': "Sila pilih alamat penghantaran yang betul.",
    Dict_language_status_0: 'Dinyahaktif',
    Dict_language_status_1: 'Diaktifkan',
    Dict_member_label_type_1: 'Label bersyarat',
    Dict_member_label_type_2: 'Label manual',
    Dict_member_level_type_0: 'Tahap penggunaan (LV)',
    Dict_member_level_type_1: 'Ahli berbayar (VIP)',
    Dict_member_growth_action_type_1: 'Buat pesanan',
    Dict_member_growth_action_type_2: 'Log masuk harian',
    Dict_member_growth_action_type_3: 'Hantar penilaian',
    Dict_member_growth_action_type_4: 'Lengkapkan profil',
    Dict_paid_member_payment_type_0: 'Pembayaran baki',
    Dict_paid_member_payment_type_1: 'WeChat Pay',
    Dict_paid_member_payment_type_2: 'Alipay',
    Dict_paid_member_payment_type_3: 'PayPal',
    Dict_paid_member_record_status_0: 'Sah',
    Dict_paid_member_record_status_1: 'Tamat tempoh',
    Dict_paid_member_record_status_2: 'Dikembalikan',
    Dict_point_lottery_prize_type_0: 'Mata',
    Dict_point_lottery_prize_type_1: 'Kupon',
    Dict_point_lottery_prize_type_2: 'Hadiah fizikal',
    Dict_point_lottery_prize_type_3: 'Terima kasih atas penyertaan',
    Dict_notification_channel_type_0: 'SMS',
    Dict_notification_channel_type_1: 'E-mel',
    Dict_notification_channel_type_2: 'Mesej dalaman',
    Dict_notification_channel_type_3: 'Pemberitahuan tolak',
    Dict_announcement_status_0: 'Draf',
    Dict_announcement_status_1: 'Diterbitkan',
    Dict_announcement_status_2: 'Ditarik',
    Dict_live_permission_status_0: 'Belum memohon',
    Dict_live_permission_status_1: 'Dalam semakan',
    Dict_live_permission_status_2: 'Diaktifkan',
    Dict_live_permission_status_3: 'Ditolak',
    Dict_live_room_status_0: 'Belum bermula',
    Dict_live_room_status_1: 'Sedang siaran langsung',
    Dict_live_room_status_2: 'Tamat',
    Dict_live_room_status_3: 'Gangguan luar biasa',
    Dict_live_room_type_0: 'Siaran langsung platform',
    Dict_live_room_type_1: 'Siaran langsung peniaga',
    Dict_store_type_0: 'Kedai individu',
    Dict_store_type_1: 'Kedai perusahaan',
    Dict_store_sign_status_0: 'Menunggu tandatangan',
    Dict_store_sign_status_1: 'Telah ditandatangani',
    Dict_store_sign_status_2: 'Ditamatkan',
    Dict_store_business_change_status_0: 'Menunggu semakan',
    Dict_store_business_change_status_1: 'Diluluskan',
    Dict_store_business_change_status_2: 'Ditolak',
    Dict_decoration_page_type_0: 'Halaman utama',
    Dict_decoration_page_type_1: 'Halaman kategori',
    Dict_decoration_page_type_2: 'Halaman kempen',
    Dict_decoration_page_type_3: 'Halaman tersuai',
    Dict_decoration_status_0: 'Draf',
    Dict_decoration_status_1: 'Diterbitkan',
    Dict_decoration_popup_trigger_page_0: 'Halaman utama platform',
    Dict_decoration_popup_trigger_page_1: 'Pusat ahli',
    Dict_decoration_popup_trigger_page_2: 'Pembayaran berjaya',
    Dict_decoration_popup_target_user_0: 'Semua pengguna',
    Dict_decoration_popup_target_user_1: 'Ahli percuma',
    Dict_decoration_popup_target_user_2: 'Ahli berbayar',
    Dict_decoration_popup_frequency_0: 'Sekali selamanya',
    Dict_decoration_popup_frequency_1: 'Setiap lawatan',
    Dict_decoration_popup_frequency_2: 'Kekerapan tersuai',
    Dict_track_event_type_page_view: 'Paparan halaman',
    Dict_track_event_type_click: 'Klik',
    Dict_track_event_type_add_to_cart: 'Tambah ke troli',
    Dict_track_event_type_search: 'Carian',
    Dict_track_event_type_purchase: 'Pembelian',
    Dict_track_event_type_live_watch: 'Tonton siaran langsung',
    Dict_reconcile_period_type_0: 'Harian',
    Dict_reconcile_period_type_1: 'Mingguan',
    Dict_reconcile_period_type_2: 'Bulanan',
    Dict_store_settlement_status_0: 'Menunggu penyelesaian',
    Dict_store_settlement_status_1: 'Diselesaikan',
    Dict_distributor_status_0: 'Menunggu semakan',
    Dict_distributor_status_1: 'Disemak',
    Dict_distributor_status_2: 'Ditolak',
    Dict_distribution_commission_type_0: 'Komisen langsung',
    Dict_distribution_commission_type_1: 'Komisen tidak langsung',
    Dict_configuration_status_0: 'Dinyahaktif',
    Dict_configuration_status_1: 'Diaktifkan',
    ...msLocale
}
export default ms
